import React from 'react'
import { NavLink } from 'react-router-dom';
import { getIcons } from '_helpers';

export {HeaderButton};

function HeaderButton({ info }) {
    return (
        <NavLink className={`nav-item nav-link header-button px-3`} to={info.pathTo}>
            {info.name}
            <div className="relative">
                <div className="header-circle-selector">
                    <img src={getIcons("headerCircle")} alt="circle"/>
                </div>
            </div>
        </NavLink>
  )
};